export default __webpack_public_path__ + "static/Portada_Inicio_Nueva-7f6fe576fec36939569f24d72e49111f.png";